import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import EditTabSettings from '../../../inputs/EditTabSettings';
import ColorPickerPopup from './ColorPickerPopup';
import IconPickerPopup from './IconPickerPopup';
import { isEqual } from 'lodash';

const EditTabStyle = (props) => {
  const [errors, setErrors] = useState({ editTabCheck: false });
  const [optionName, setOptionName] = useState('');
  const [icon, setIcon] = useState('');

  // Use useSelector with a custom equality function to ensure updates on all_tabs changes
  const all_tabs = useSelector((state) => state.settings_site.all_tabs, isEqual);
  const edit_tab = useSelector((state) => state.settings_admin.edit_tab);

  // Memoize the tab selection to avoid unnecessary recomputations
  const tab = useMemo(() => {
    const tabName = props.edit_tab || edit_tab || '';
    if (!tabName || !all_tabs) return null;
    const value = _.sortBy(_.filter(all_tabs, (o) => o.name === tabName), 'id');
    return value[0] || null;
  }, [all_tabs, props.edit_tab, edit_tab]);

  // If no tab is found, render a fallback UI
  if (!tab) {
    return (
      <div className="col-md-12">
        <div className="card space-top-1">
          <div className="card-body">
            <div className="alert alert-warning" role="alert">
              <i className="fa fa-exclamation-circle me-2" />
              No tab selected or tab not found.
            </div>
          </div>
        </div>
      </div>
    );
  }

  const defaultStyle = {
    background: tab.icon_bg_color,
    backgroundColor: tab.icon_bg_color,
    color: tab.icon_font_color,
  };

  const pendingStyle = {
    background: tab.icon_pending_bg_color,
    backgroundColor: tab.icon_pending_bg_color,
    color: tab.icon_pending_font_color,
  };

  const successStyle = {
    background: tab.icon_success_bg_color,
    backgroundColor: tab.icon_success_bg_color,
    color: tab.icon_success_font_color,
  };

  const warningStyle = {
    background: tab.icon_warning_bg_color,
    backgroundColor: tab.icon_warning_bg_color,
    color: tab.icon_warning_font_color,
  };

  const statusArray = ['default', 'pending', 'success', 'warning'];

  return (
    <div className="col-md-12">
      <div className="card space-top-1">
        <div className="card-header">
          <div className="col-md-12">
            <small>
              <i className="fa fa-info-circle text-info" />
              {' '}
              Settings only affect this tab. Use "Global Settings" to set the default colors for all tabs.
            </small>
          </div>
        </div>
        <div className="card-body">
          <table className="table table-striped table-sm">
            <thead className="thead text-center">
              <tr>
                <th>Status</th>
                <th>Icon</th>
                <th>Font Color</th>
                <th>Background Color</th>
              </tr>
            </thead>
            <tbody>
              {statusArray.map((status) => (
                <tr key={`status_${status}`}>
                  <th className="text-center text-capitalize">{status}</th>
                  <td className="text-center">
                    <IconPickerPopup
                      {...props}
                      value={tab[`icon${status === 'default' ? '' : `_${status}`}`] || tab.icon}
                      name={`icon${status === 'default' ? '' : `_${status}`}`}
                      dataid={tab.id}
                      edit_tab={props.edit_tab || edit_tab}
                      bg_color={tab[`icon${status === 'default' ? '' : `_${status}`}_bg_color`]}
                      font_color={tab[`icon${status === 'default' ? '' : `_${status}`}_font_color`]}
                    />
                  </td>
                  <td className="text-center">
                    <ColorPickerPopup
                      {...props}
                      type="colorpicker"
                      name={`icon${status === 'default' ? '' : `_${status}`}_font_color`}
                      value={tab[`icon${status === 'default' ? '' : `_${status}`}_font_color`]}
                      dataid={tab.id}
                      cat="tab"
                      edit_tab={props.edit_tab || edit_tab}
                      bg_color={tab[`icon${status === 'default' ? '' : `_${status}`}_bg_color`]}
                      font_color={tab[`icon${status === 'default' ? '' : `_${status}`}_font_color`]}
                    />
                  </td>
                  <td className="text-center">
                    <ColorPickerPopup
                      {...props}
                      type="colorpicker"
                      name={`icon${status === 'default' ? '' : `_${status}`}_bg_color`}
                      value={tab[`icon${status === 'default' ? '' : `_${status}`}_bg_color`]}
                      dataid={tab.id}
                      cat="tab"
                      edit_tab={props.edit_tab || edit_tab}
                      bg_color={tab[`icon${status === 'default' ? '' : `_${status}`}_bg_color`]}
                      font_color={tab[`icon${status === 'default' ? '' : `_${status}`}_font_color`]}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="card space-top-1">
        <div className="card-header">
          <div className="col-md-12">
            <small>
              <i className="fa fa-info-circle text-info" />
              {' '}
              Default comparisons vary for each tab. Ask a Recon Advisor support agent for best practices.
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTabStyle;
